import type { ReactNode } from 'react';

import type { ToolUseItem } from '../../../contracts/harness.types';
import { InlineToolCallRow } from './InlineToolCallRow';

import { GET_NOTE_VERIFICATION_ANALYSIS_TOOL_NAME } from '../../../contracts/projects/VerifySubagentInlineBlock.utils';
import { readToolResultText } from '../../../contracts/toolResult';
import type { BlockStatus } from '../../../data/projects/timeline/presentation/types';

/**
 * Parent-facing Heidi Verify read tool — render source-grounded markdown from
 * the tool result when the analysis text is available. The settled markdown
 * renders through `renderAssistantText`, which the timeline dispatcher binds to
 * its assistant text block.
 */
export const renderVerifyToolUse = (
  item: ToolUseItem,
  status: BlockStatus,
  renderAssistantText: (text: string) => ReactNode
): ReactNode | null => {
  if (item.name !== GET_NOTE_VERIFICATION_ANALYSIS_TOOL_NAME) return null;
  if (status !== 'success') return null;

  const text = readToolResultText(item)?.trim();
  if (!text) return null;

  return (
    <div className="flex w-full flex-col gap-2" data-testid="verify-analysis-result">
      <InlineToolCallRow
        toolName={item.name}
        toolInput={item.input}
        status={status}
        toolCallDisplay={item.toolCallDisplay}
      />
      {renderAssistantText(text)}
    </div>
  );
};
